const NAMED_HTML_ENTITIES: Record<string, string> = {
  amp: "&",
  apos: "'",
  gt: ">",
  lt: "<",
  nbsp: String.fromCharCode(160),
  quot: "\"",
};

export function decodeHtmlEntities(value: string) {
  if (!value.includes("&")) return value;

  return value.replace(
    /&(#\d+|#x[\da-f]+|[a-z][a-z0-9]+);/gi,
    (match, entity: string) => {
      if (entity.startsWith("#x") || entity.startsWith("#X")) {
        const codePoint = Number.parseInt(entity.slice(2), 16);
        return decodeCodePoint(codePoint, match);
      }

      if (entity.startsWith("#")) {
        const codePoint = Number.parseInt(entity.slice(1), 10);
        return decodeCodePoint(codePoint, match);
      }

      return NAMED_HTML_ENTITIES[entity.toLowerCase()] || match;
    },
  );
}

function decodeCodePoint(codePoint: number, fallback: string) {
  if (!Number.isFinite(codePoint)) return fallback;

  try {
    return String.fromCodePoint(codePoint);
  } catch {
    return fallback;
  }
}
